import newProjectSettingsReducer from "./slices/newProjectSettingsSlice";
import noteReducer from "./slices/NoteSlice";
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import calendarReducer from "./slices/calendarSlice";
import resourcesReducer from "./slices/ResourcesSlice";
import baseTableReducer from "./slices/BaseTableSlice";
import baseMenuReducer from "./slices/BaseMenuSlice";
import notificationReducer from "./slices/notificationSlice";
import imageReducer from "./slices/ImageSlice";
import projectReducer from "./slices/projectSlice";
import projectTypeReducer from "./slices/projectTypeSlice"; // הוספה חדשה
import contactReducer from "./slices/contactSlice"; // הוסף את השורה הזו
import resourceDiaryReducer from "./slices/resourceDiarySlice";
import { companyChangeMiddleware } from "./middleware/companyChangeMiddleware";
import { apiErrorMiddleware } from "./middleware/apiErrorMiddleware";
import milestonesReducer from "./slices/MilestonesSlice";
import customFieldReducer from "./slices/customFieldSlice";
import baseItemReducer from "./slices/BaseItemSlice";
import baseStatusReducer from "./slices/BaseStatusSlice";
import bookkeepingDocumentReducer from "./slices/bookkeepingDocumentSlice";
import documentTypesReducer from "./slices/documentTypesSlice"; // הוספה חדשה
import appointmentReducer from "./slices/appointmentSlice";
import userReducer from "./slices/userSlice";
import appointmentTypeReducer from "./slices/appointmentTypeSlice";
import paymentDataReducer from "./slices/paymentDataSlice";
import leadReducer from "./slices/leadSlice";
import contractReducer from "./slices/contractSlice";
import documentSettingsReducer from "./slices/documentSettingsSlice";
import documentParamsReducer from "./slices/documentParamsSlice";
import projectAccountReducer from "./slices/projectAccountSlice";
import fileDownloadReducer from "./slices/fileDownloadSlice";
import companyInfoReducer from "./slices/companySlice";
import userCompanyReducer from "./slices/userCompanySlice";
import reasonReducer from "./slices/reasonSlice";
import taskReducer from "./slices/taskSlice";
import activityReducer from "./slices/activitySlice";
import iconReducer from "./slices/iconSlice";
import legalAppendiceReducer from "./slices/legalAppendiceSlice";
import projectMenuReducer from "./slices/projectMenuSlice";
import menuSelectionReducer from "./slices/menuSelectionSlice";
import tagValueReducer from "./slices/tagValueSlice";
import reportReducer from "./slices/reportSlice";
import reportPdfReducer from "./slices/reportPdfSlice";
import reportExcelReducer from "./slices/reportExcelSlice";
import reportEmailReducer from "./slices/reportEmailSlice";
// import documentViewHtmlReducer from "./slices/documentViewHtmlSlice";
import convertDocumentTemplateReducer from "./slices/convertDocumentTemplateSlice";
import projectDocumentDataReducer from "./slices/projectDocumentDataSlice";
import whatsAppReducer from "./slices/whatsAppSlice";
import pusherNotificationsReducer from "./slices/pusherNotificationsSlice";
import openFormatReducer from "./slices/openFormatSlice";
import israelInvoiceReducer from "./slices/israelInvoiceSlice";
import dashboardReducer from "./slices/DashboardSlice";
import automationReducer from "./slices/automationSlice"; // הוספה חדשה
import phoneCallReducer from "./slices/phoneCallSlice";
import digitalOrderReducer from "./slices/digitalOrderSlice";
import globalSearchReducer from "./slices/globalSearchSlice";
import fileStorageReducer from "./slices/fileStorageSlice";
import documentEditingReducer from "./slices/documentEditingSlice";
import bookkeepingEditingReducer from "./slices/bookkeepingEditingSlice";
import msgTemplateReducer from "./slices/msgTemplateSlice";
const _store = configureStore({
  reducer: {
    msgTemplate: msgTemplateReducer,
    newProjectSettings: newProjectSettingsReducer,
    auth: authReducer,
    calendar: calendarReducer,
    resources: resourcesReducer,
    baseTables: baseTableReducer,
    image: imageReducer,
    baseMenu: baseMenuReducer,
    notification: notificationReducer,
    project: projectReducer,
    projectTypes: projectTypeReducer, // הוספה חדשה
    contact: contactReducer,
    resourceDiary: resourceDiaryReducer,
    milestones: milestonesReducer,
    customField: customFieldReducer,
    baseItem: baseItemReducer,
    baseStatus: baseStatusReducer,
    bookkeepingDocument: bookkeepingDocumentReducer,
    documentTypes: documentTypesReducer, // הוספה חדשה
    paymentData: paymentDataReducer, // הוספה חדשה
    note: noteReducer,
    lead: leadReducer,
    contract: contractReducer,
    documentSettings: documentSettingsReducer,
    documentParams: documentParamsReducer,
    projectAccount: projectAccountReducer,
    fileDownload: fileDownloadReducer,
    companyInfo: companyInfoReducer,
    userCompany: userCompanyReducer,
    reason: reasonReducer,
    task: taskReducer,
    activity: activityReducer,
    tagValue: tagValueReducer,
    legalAppendice: legalAppendiceReducer,
    icon: iconReducer,
    projectMenu: projectMenuReducer,
    menuSelection: menuSelectionReducer,
    report: reportReducer,
    reportPdf: reportPdfReducer,
    reportExcel: reportExcelReducer,
    reportEmail: reportEmailReducer,
    // documentViewHtml: documentViewHtmlReducer,
    convertDocumentTemplate: convertDocumentTemplateReducer,
    documentEditing: documentEditingReducer,
    bookkeepingEditing: bookkeepingEditingReducer,
    projectDocumentData: projectDocumentDataReducer,
    whatsApp: whatsAppReducer,
    pusherNotifications: pusherNotificationsReducer,
    openFormat: openFormatReducer,
    israelInvoice: israelInvoiceReducer,
    dashboard: dashboardReducer,
    automation: automationReducer, // הוספה חדשה
    phoneCall: phoneCallReducer,
    globalSearch: globalSearchReducer,
    digitalOrder: digitalOrderReducer,
    fileStorage: fileStorageReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // 🔥 התעלמות מכל בעיות Serialization
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
          "fileDownload/downloadFile/fulfilled",
          "fileDownload/downloadAndSaveFile/fulfilled",
          "fileDownload/downloadFile/rejected",
          "fileDownload/downloadAndSaveFile/rejected",
          "fileDownload/downloadFile/pending",
          "fileDownload/downloadAndSaveFile/pending",
        ],
        ignoredPaths: [
          "register",
          "rehydrate",
          "fileDownload.blob",
          "project.projectHeader.projectCreateDate",
          "project.projectHeader",
        ],
      },
    }),
});

// יצירת store מחדש עם middleware
export const finalStore = configureStore({
  reducer: {
    newProjectSettings: newProjectSettingsReducer,
    auth: authReducer,
    calendar: calendarReducer,
    baseMenu: baseMenuReducer,
    resources: resourcesReducer,
    baseTables: baseTableReducer,
    notification: notificationReducer,
    image: imageReducer,
    project: projectReducer,
    projectTypes: projectTypeReducer, // הוספה חדשה
    contact: contactReducer,
    resourceDiary: resourceDiaryReducer,
    milestones: milestonesReducer,
    customField: customFieldReducer,
    baseItem: baseItemReducer,
    baseStatus: baseStatusReducer,
    bookkeepingDocument: bookkeepingDocumentReducer,
    documentTypes: documentTypesReducer,
    paymentData: paymentDataReducer, // הוספה חדשה
    appointment: appointmentReducer,
    user: userReducer,
    appointmentType: appointmentTypeReducer,
    note: noteReducer,
    lead: leadReducer,
    contract: contractReducer,
    documentSettings: documentSettingsReducer,
    documentParams: documentParamsReducer,
    projectAccount: projectAccountReducer,
    fileDownload: fileDownloadReducer,
    companyInfo: companyInfoReducer,
    userCompany: userCompanyReducer,
    reason: reasonReducer,
    task: taskReducer,
    activity: activityReducer,
    tagValue: tagValueReducer,
    legalAppendice: legalAppendiceReducer,
    icon: iconReducer,
    projectMenu: projectMenuReducer,
    menuSelection: menuSelectionReducer,
    report: reportReducer,
    reportPdf: reportPdfReducer,
    reportExcel: reportExcelReducer,
    reportEmail: reportEmailReducer,
    // documentViewHtml: documentViewHtmlReducer,
    convertDocumentTemplate: convertDocumentTemplateReducer,
    documentEditing: documentEditingReducer,
    bookkeepingEditing: bookkeepingEditingReducer,
    projectDocumentData: projectDocumentDataReducer,
    whatsApp: whatsAppReducer,
    pusherNotifications: pusherNotificationsReducer,
    openFormat: openFormatReducer,
    israelInvoice: israelInvoiceReducer,
    dashboard: dashboardReducer,
    automation: automationReducer, // הוספה חדשה
    phoneCall: phoneCallReducer,
    globalSearch: globalSearchReducer,
    digitalOrder: digitalOrderReducer,
    fileStorage: fileStorageReducer,
    msgTemplate: msgTemplateReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
        ignoredPaths: [
          "project.currentProject.createdDate",
          "project.currentProject.resourceDiary.startTime",
          "project.currentProject.resourceDiary.endTime",
          "customField.customFields",
          "project.projects",
        ],
        ignoredActionsPaths: [
          "payload.timestamp",
          "meta.arg",
          "meta.baseQueryMeta",
        ],
        warnAfter: 128,
      },
      immutableCheck: {
        warnAfter: 128,
      },
    })
      .concat(companyChangeMiddleware)
      .concat(apiErrorMiddleware),
});

// הגדרת types
export type RootState = ReturnType<typeof finalStore.getState>;
export type AppDispatch = typeof finalStore.dispatch;

export { finalStore as store };
